import { createContext, type Dispatch, type SetStateAction } from 'react';

interface SlideShowContextType {
  setActiveSlide: Dispatch<SetStateAction<number>>;
  activeSlide: number;
  slidesQuantity: number;
}

const SlideShowContext = createContext({} as SlideShowContextType);

export { SlideShowContext };
